export const RFM_CURRENCIES = ["EUR", "CHF", "GBP", "USD"];
export const RFM_ANALYSIS_PERIOD_MIN = 1;
export const RFM_ANALYSIS_PERIOD_MAX = 120;
/** Ceiling of a monetary threshold — the OPDON column is `numeric(10,2)`. */
export const RFM_MONETARY_THRESHOLD_MAX = 99999999.99;
/** MMP grid (OP-4573) — must stay equal to `RfmSettingsValues.Default` on the backend. */
export const RFM_DEFAULTS = {
    analysisPeriodMonths: 24,
    recency: { thresholds: [3, 6, 12, 24], weight: 40 },
    frequency: { thresholds: [2, 3, 4, 5], weight: 30 },
    monetary: { thresholds: [50, 200, 500, 1000], currency: "EUR", weight: 30 },
    updatedAt: null,
};
export function createDefaultRfmSettings() {
    return structuredClone(RFM_DEFAULTS);
}
